import { PaginationMeta, AssociateUserFilter, AssociateUser } from '../types';

export interface IAssociateUserState {
  associateUsers: AssociateUser[];
  associateUserPaginationMeta: PaginationMeta;
  appliedFilter: AssociateUserFilter;
}

export const AssociateUserState: IAssociateUserState = {
  associateUsers: [],
  associateUserPaginationMeta: {} as PaginationMeta,
  appliedFilter: {
    searchKeyword: ''
  }
};
